import { useMemo, useState, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useSetupISACustomSegmentsStore } from '../SetupISACustomSegments.store';
import { CustomSegmentParams } from '../types';

export const useGetCustomSegmentTableList = () => {
  const { setSetupISACustomSegmentsState } = useSetupISACustomSegmentsStore();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [sort, setSort] = useState<{ id: string; direction: CustomSegmentParams['direction'] }>({ id: 'CRIADO_EM', direction: 'DESC' });

  const { mutate, data, isPending } = useMutation({
    mutationFn: (params: any) => service.getCustomSegment(params),
    onSuccess: data => {
      setSetupISACustomSegmentsState('customSegmentData', data);
    },
  });

  const fetchSegments = (pageParam: number, sizeParam: number, sortParam?: typeof sort) => {
    mutate({
      page: pageParam - 1,
      size: sizeParam,
      sort: sortParam?.id,
      direction: sortParam?.direction ?? 'ASC',
    });
  };

  const handleChangeCustomSegmentPage = (newPage: number) => {
    setPage(newPage);
    fetchSegments(newPage, size, sort);
  };

  const handleChangeCustomSegmentSort = (id: string, direction: CustomSegmentParams['direction']) => {
    const newSort = { id, direction };
    setSort(newSort);
    fetchSegments(page, size, newSort);
  };

  const handleChangeCustomSegmentLength = (length: number) => {
    setSize(length);
    setPage(1);
    fetchSegments(1, length, sort);
  };

  useEffect(() => {
    fetchSegments(1, 10, sort);
  }, []);

  const segment = useMemo(() => data, [data]);

  return {
    segmentData: segment,
    handleChangeCustomSegmentPage,
    handleChangeCustomSegmentSort,
    handleChangeCustomSegmentLength,
    isLoading: isPending,
  };
};
